import type { LabelAssignment } from '@provision/entity-types';
import { getEffectiveServiceLevelForAddress } from '@provision/service-level-utils';

// thin wrapper over the shared policy seam so this surface resolves Service Level identically to the
// backend (`get-applicable-support-policies.ts`)
export function getApplicablePolicyServiceLevel(address: {
  platformSlaId?: string | null;
}): string | null {
  return getEffectiveServiceLevelForAddress(address);
}

export function getPolicyAddressLabelAssignments(
  address: {
    addressId?: string | null;
    labelAssignments?: LabelAssignment[] | null;
  },
  labelAssignmentsMap: ReadonlyMap<string, LabelAssignment[]>,
): LabelAssignment[] {
  if (address.addressId) {
    const hydratedAssignments = labelAssignmentsMap.get(address.addressId);

    if (hydratedAssignments) {
      return hydratedAssignments;
    }
  }

  return address.labelAssignments ?? [];
}
